import { Button, IconButton, PancakeStack, Separator } from '@betterment/samba-react';

import ErrorMessage from './ErrorMessage';
import RoadBlockIcon from './RoadblockIcon';

const MobileErrorFallback = () => {
  return (
    <PancakeStack css={{ maxWidth: 'screen', height: '100vh', p: 'space.200' }}>
      <PancakeStack.Header css={{ maxWidth: 'screen', display: 'flex', justifyContent: 'end' }}>
        <IconButton name="X" aria-label="Close page" label="Close page" onClick={() => window.location.reload()} />
      </PancakeStack.Header>

      <PancakeStack.Main css={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 'space.400' }}>
        <RoadBlockIcon />
        <ErrorMessage />
      </PancakeStack.Main>

      <PancakeStack.Footer css={{ display: 'grid', gap: 'space.100' }}>
        <Separator />
        <Button css={{ width: '100%' }} onClick={() => window.location.reload()}>
          Reload
        </Button>
      </PancakeStack.Footer>
    </PancakeStack>
  );
};

export default MobileErrorFallback;
